import { render, staticRenderFns } from "./modal-all-files-management.vue?vue&type=template&id=89e4e0ea&scoped=true&"
import script from "./modal-all-files-management.vue?vue&type=script&lang=js&"
export * from "./modal-all-files-management.vue?vue&type=script&lang=js&"
import style0 from "./modal-all-files-management.vue?vue&type=style&index=0&id=89e4e0ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e4e0ea",
  null
  
)

export default component.exports